import * as React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps, Color } from '@material-ui/lab/Alert';
import { initFalse } from '../../utils/constants';

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

type AlertMessageProp = {
  message: string;
  open: boolean;
  severity: Color;
  setOpen: (open: boolean) => void;
  autoHide?: number
}

export default ({message, open, severity, setOpen, autoHide}: AlertMessageProp) => {
  const handleClose = () => setOpen(initFalse);

  if (!message) {
    return null;
  }

  return (
    <Snackbar
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      autoHideDuration={autoHide ? autoHide : 5000}
      onClose={handleClose}
      open={open}
    >
      <Alert onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  )
}
